import React from "react";

export default function SQL_Null_Values() {
  return (
    <div className="p-4">
      <h1 className="text-2xl font-bold">SQL_Null_Values</h1>
      <p>This is the SQL_Null_Values component generated from the SQL JSON.</p>
    </div>
  );
}
